// extracted by mini-css-extract-plugin
export default {"AnchorTo":"index__AnchorTo--P-dbc","anchorTo":"index__AnchorTo--P-dbc","Anchor":"index__Anchor--NGK8V","anchor":"index__Anchor--NGK8V"};